import {svgIconWrapper} from '../svg-icon-wrapper';

import FireSolid from './fire-solid-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FireSolid {...validProps} />;
}
SvgComponent.iconName = 'fireSolid';

export const FireSolidIcon = svgIconWrapper(SvgComponent);
